/**
 * Migrated by mariushirjanu on 30/06/2020.
 */
import { Directive, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { Input } from '@angular/core';
import { ScrollService } from './scroll.service';

@Directive({
  selector: '[scrollTarget]'
})
export class ScrollTargetDirective implements AfterViewInit, OnDestroy {
  @Input() public scrollTarget:string;
  @Input() public scrollPaddingTop:number;

  constructor(
    private elementRef:ElementRef<HTMLElement>,
    private scrollService:ScrollService
  ) {
    /**/
  }

  public ngAfterViewInit():void {
    if (!this.scrollTarget) {
      return;
    }

    const scrollPaddingTop:number = Number(this.scrollPaddingTop || 0);

    const scroll = () => {
      this.scrollService.scrollToElement($(this.elementRef.nativeElement), scrollPaddingTop);
    };

    this.scrollService.registerScrollTarget(this.scrollTarget, { scroll });

    if (this.scrollTarget === this.scrollService.getCurrentTarget()) {
      scroll();
      //single serve
      this.scrollService.clear();
    }
  }

  public ngOnDestroy():void {
    this.scrollService.unregisterScrollTarget(this.scrollTarget);
  }
}